import { IUserPermissions } from 'types/auth'
import { IComplianceCoverReviewStatuses } from 'types/graphqlTypes'
import { IComplianceReviewFragment } from '../graphql/ComplianceCoverReviewFragment'

export function isShipmentReadyToOffer(
  carrierMeetsRequirements: boolean,
  complianceCoverReviewStatus: IComplianceCoverReviewStatuses | undefined
) {
  return (
    carrierMeetsRequirements ||
    (!carrierMeetsRequirements &&
      complianceCoverReviewStatus === IComplianceCoverReviewStatuses.approved)
  )
}

export function canReviewCompliance(
  userPermissions: IUserPermissions | null,
  complianceCoverReview: IComplianceReviewFragment | null | undefined
) {
  const { canManageComplianceCoverReviews } = userPermissions || {}
  const { status: complianceCoverReviewStatus } = complianceCoverReview || {}
  return (
    complianceCoverReview &&
    complianceCoverReviewStatus === IComplianceCoverReviewStatuses.active_needs_review &&
    canManageComplianceCoverReviews
  )
}

export function getComplianceHeading(
  carrierMeetsRequirements: boolean,
  complianceCoverReviewStatus: IComplianceCoverReviewStatuses | undefined
) {
  if (isShipmentReadyToOffer(carrierMeetsRequirements, complianceCoverReviewStatus)) {
    return 'Ready to Offer'
  }
  if (complianceCoverReviewStatus === IComplianceCoverReviewStatuses.active_in_review) {
    return 'In Compliance Review'
  }
  return 'Needs Compliance Review'
}

export function getComplianceRequirementsLabel(
  carrierMeetsRequirements: boolean,
  complianceCoverReviewStatus: IComplianceCoverReviewStatuses | undefined
) {
  if (isShipmentReadyToOffer(carrierMeetsRequirements, complianceCoverReviewStatus)) {
    return 'Compliance requirements met by carrier'
  }
  return 'Compliance requirements not met by carrier'
}
